import VehicleChart from "./components/VehiclesChart";

export default function App() {
  return (
    <div>
     <VehicleChart/>
    </div>
  );
}
